<template>
  <div class="vz-order-total-price-get-btn" @mousedown.stop @touchstart.stop @touchend.stop>
    <vz-button
      v-if="hasDraftButton"
      big
      link
      icon-name="content-save"
      icon-size="18"
      variant="primary"
      class="vz-order-total-price-get-btn--draft-link"
      @click="emit('create-draft')"
      style="line-height: 17px; padding-left: 0"
    >
      <div>
        {{ saveDraftTitle }}
      </div>
    </vz-button>
    <div v-if="visibility" class="vz-order-total-price-get-btn--main">
      <vz-button
        v-if="draftAsButton && isNewOrder && isAuth"
        big
        icon-name="content-save"
        icon-size="18"
        variant="primary"
        class="vz-order-total-price-get-btn--draft-link"
        :class="itemClass"
        style="padding: 12px"
      />
      <vz-button
        big
        variant="primary"
        :class="itemClass"
        @click="emit('send-form')"
      >
        {{ sendTitle }}
      </vz-button>
      <vz-button
        big
        :class="itemClass"
        @click="emit('get-price')"
      >
        Пересчитать
      </vz-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import {storeToRefs} from 'pinia';
import {useOrderStore} from '~/stores/order';
import {useUserStore} from '~/stores/personal/user';

const emit = defineEmits(['send-form', 'get-price', 'create-draft'])

const props = defineProps({
  itemClass: {
    type: String,
    default: 'mx-2 mt-10'
  },
  draftAsButton: {
    type: Boolean,
    default: false
  }
})

const { orderForm } = storeToRefs(useOrderStore())
const { isAuth } = storeToRefs(useUserStore())
const route = useRoute()

const isNewOrder = computed(() => {
  return !route.params.guid
})

const isLightOrder = computed(() => {
  return route.name === 'order-light'
})

const hasDraftButton = computed(() => {
  return !props.draftAsButton && isNewOrder.value && isAuth.value && !isLightOrder.value
})

const sendTitle = computed(() => {
  return isNewOrder.value ? 'Оформить' : 'Подтвердить'
})

const saveDraftTitle = computed(() => {
  return orderForm.value?.meta?.draftId ? 'Сохранить черновик' : 'Сохранить как черновик'
})

const visibility = computed(() => {
  if (isLightOrder.value) {
    return false
  }
  return isNewOrder.value || !!orderForm.value?.meta?.favorList?.getPrice
})
</script>

<style lang="scss" scoped>
</style>
